import { tx, onEvent, TRANSLATIONS_FETCH_FAILED, } from '@transifex/native';
import { FallbackMissingPolicy } from '../FallbackMissingPolicy';
import { FallbackErrorPolicy } from '../FallbackErrorPolicy';
import { getFallbackMessage } from '../translationsCache';
export function initTransifexWithFallback(config) {
    const { onError = console.warn } = config;
    tx.init(Object.assign({ missingPolicy: new FallbackMissingPolicy(), errorPolicy: new FallbackErrorPolicy(onError) }, config));
    onEvent(TRANSLATIONS_FETCH_FAILED, (payload) => {
        if (!payload) {
            onError('Failed to fetch translations. Payload is null. Using fallback translations.');
            tx.t = (sourceString, params) => getFallbackMessage(sourceString, 'en', params);
            return;
        }
        const { localeCode, filterTags } = payload;
        onError(`Failed to fetch translations for locale ${localeCode} with filterTags: ${filterTags || 'none'}. Using fallback translations.`);
        tx.t = (sourceString, params) => getFallbackMessage(sourceString, localeCode, params);
    });
    return tx;
}
//# sourceMappingURL=initTransifexWithFallback.js.map